/**
 * Serializes the form with the given selector to a URLSearchParams string
 * or object.
 *
 * @param {string} formSelector - The CSS selector for the form to serialize.
 * @param {boolean} [asString=true] - Whether to return a string or object.
 * @returns {string|URLSearchParams} The serialized form data.
 */
const serializeForm = function (
    formSelector: string,
    asString: boolean = true
): string | URLSearchParams {
    let form: HTMLFormElement | null = document.querySelector(formSelector);
    if (form) {
        let data = new FormData(form);
        let params = new URLSearchParams(data as any);
        return asString ? params.toString() : params;
    } else {
        return '';
    }
};

export { serializeForm };
